import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';


@Component({
    selector: 'app-tourisme',
    templateUrl: './tourisme.component.html',
    styleUrls: ['./tourisme.component.scss']
})
export class TourismeComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);

    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville'/*, 'france'*/];

    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d} %)'
        },
        calculable: true,
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            data: ['Établissements de tourisme', 'Aéroports', 'Agences de voyages', 'Campings', 'Gare locale', 'Gare nationale', 'Gare régionale', 'Hôtels', 'Informations touristiques', 'Taxis']
        },
    };

    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        // Vue partagée : la ville arrive sans les données tourisme -> ne rien afficher
        if (!this.favorite.ad_city || !this.favorite.ad_city.tourisme) {
            return;
        }
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.tourisme_iris && this.favorite.ad_city.tourisme_iris[this.iris]) {
            irisData = this.favorite.ad_city.tourisme_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.tourisme_gq && this.favorite.ad_city.tourisme_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.tourisme_gq[this.secteur];
        }

        let root = this.favorite.ad_city.tourisme;
        // Donnée absente (ex. payload de partage allégé) -> widget muet, pas de plantage
        if (!root) {
            return;
        }
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        this.data = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],

                    data: [
                        {
                            value: Math.round(root.tot_tourisme),
                            name: (Math.round(root.tot_tourisme)).toString() + '\nÉtablissements\nde tourisme'
                        },

                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    radius: ['55%', '81%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5
                    },
                    color: [],
                    data: [],
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        if (root.aero) {
            this.data.series[1].data.push({value: Math.round(root.aero), name: 'Aéroports'});
            this.data.series[1].color.push('#67C2EF');
        }

        if (root.agence_voy) {
            this.data.series[1].data.push({value: Math.round(root.agence_voy), name: 'Agences de voyages'});
            this.data.series[1].color.push('#79C447');
        }

        if (root.camping) {
            this.data.series[1].data.push({value: Math.round(root.camping), name: 'Campings'});
            this.data.series[1].color.push('#FABB3D');
        }

        if (root.gare_loc) {
            this.data.series[1].data.push({value: Math.round(root.gare_loc), name: 'Gare locale'});
            this.data.series[1].color.push('#1277AA');
        }

        if (root.gare_nat) {
            this.data.series[1].data.push({value: Math.round(root.gare_nat), name: 'Gare nationale'});
            this.data.series[1].color.push('#3389B3');
        }

        if (root.gare_reg) {
            this.data.series[1].data.push({value: Math.round(root.gare_reg), name: 'Gare régionale'});
            this.data.series[1].color.push('#57A1C5');
        }

        if (root.hotel) {
            this.data.series[1].data.push({value: Math.round(root.hotel), name: 'Hôtels'});
            this.data.series[1].color.push('#9C9C9C');
        }

        if (root.info_tour) {
            this.data.series[1].data.push({value: Math.round(root.info_tour), name: 'Informations touristiques'});
            this.data.series[1].color.push('#FF5455');
        }

        if (root.taxi) {
            this.data.series[1].data.push({value: Math.round(root.taxi), name: 'Taxis'});
            this.data.series[1].color.push('#B27805');
        }


        this.compare = [
            {
                'lib': 'Établissements de tourisme',
                'quartier': (irisData != null ? irisData.tot_tourisme : '-'),
                'secteur': (secteurData != null ? secteurData.tot_tourisme : '-'),
                'ville': this.favorite.ad_city.tourisme.tot_tourisme,
                // 'france': this.favorite.ad_city.tourisme_fr.tot_tourisme,
            },
            {
                'lib': 'Aéroports',
                'quartier': (irisData != null ? irisData.aero : '-'),
                'secteur': (secteurData != null ? secteurData.aero : '-'),
                'ville': this.favorite.ad_city.tourisme.aero,
                // 'france': this.favorite.ad_city.tourisme_fr.aero,
            },
            {
                'lib': 'Agences de voyages',
                'quartier': (irisData != null ? irisData.agence_voy : '-'),
                'secteur': (secteurData != null ? secteurData.agence_voy : '-'),
                'ville': this.favorite.ad_city.tourisme.agence_voy,
                // 'france': this.favorite.ad_city.tourisme_fr.agence_voy,
            },
            {
                'lib': 'Campings',
                'quartier': (irisData != null ? irisData.camping : '-'),
                'secteur': (secteurData != null ? secteurData.camping : '-'),
                'ville': this.favorite.ad_city.tourisme.camping,
                // 'france': this.favorite.ad_city.tourisme_fr.camping,
            },
            {
                'lib': 'Gare locale',
                'quartier': (irisData != null ? irisData.gare_loc : '-'),
                'secteur': (secteurData != null ? secteurData.gare_loc : '-'),
                'ville': this.favorite.ad_city.tourisme.gare_loc,
                // 'france': this.favorite.ad_city.tourisme_fr.gare_loc,
            },
            {
                'lib': 'Gare nationale',
                'quartier': (irisData != null ? irisData.gare_nat : '-'),
                'secteur': (secteurData != null ? secteurData.gare_nat : '-'),
                'ville': this.favorite.ad_city.tourisme.gare_nat,
                // 'france': this.favorite.ad_city.tourisme_fr.gare_nat,
            },
            {
                'lib': 'Gare régionale',
                'quartier': (irisData != null ? irisData.gare_reg : '-'),
                'secteur': (secteurData != null ? secteurData.gare_reg : '-'),
                'ville': this.favorite.ad_city.tourisme.gare_reg,
                // 'france': this.favorite.ad_city.tourisme_fr.gare_reg,
            },
            {
                'lib': 'Hôtels',
                'quartier': (irisData != null ? irisData.hotel : '-'),
                'secteur': (secteurData != null ? secteurData.hotel : '-'),
                'ville': this.favorite.ad_city.tourisme.hotel,
                // 'france': this.favorite.ad_city.tourisme_fr.hotel,
            },
            {
                'lib': 'Informations touristiques',
                'quartier': (irisData != null ? irisData.info_tour : '-'),
                'secteur': (secteurData != null ? secteurData.info_tour : '-'),
                'ville': this.favorite.ad_city.tourisme.info_tour,
                // 'france': this.favorite.ad_city.tourisme_fr.info_tour,
            },
            {
                'lib': 'Taxis',
                'quartier': (irisData != null ? irisData.taxi : '-'),
                'secteur': (secteurData != null ? secteurData.taxi : '-'),
                'ville': this.favorite.ad_city.tourisme.taxi,
                // 'france': this.favorite.ad_city.tourisme_fr.taxi,
            }
        ];
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
